const $ = jQuery.noConflict();

'use strict';
const LanguageSwitcher = {
	urlLang: '',

	/** @description Initialize class */
	init: function() {
		this.bindEvents();
	},

	bindEvents: ()=> {
		// on back browser event, reload the page
		$(window).on('pageshow', function(event) {
			if (event.originalEvent.persisted) {
				window.location.reload();
			}
		});
		setTimeout(()=>{
			const langUrl = LanguageSwitcher.getUrlLanguage();
			console.log(langUrl);
			if (langUrl) {
				// LanguageSwitcher.changeLanguage(langCode ? langCode : 'en');
				LanguageSwitcher.changeLanguage(langUrl);
				$('.gt-lang-code').text(langUrl);
			}
		}, 0);
		// change url on click language in dropdown
		$('.gt_options a[data-gt-lang]').on('click', function(event) {
			event.preventDefault();
			LanguageSwitcher.changeUrlLang(event, $(this).data('gt-lang'));
			// LanguageSwitcher.removeEnglishParamFromURL();
		});
		// remove en prefix from the url
		// jQuery(document).ready(()=> {
		// 	LanguageSwitcher.removeEnglishParamFromURL();
		// });
	},

	// removeEnglishParamFromURL: ()=>{
	// 	const currentUrl = window.location.href;
	// 	if (currentUrl.includes('/en/')) {
	// 		const newUrl = currentUrl.replace('/en/', '/');
	// 		window.history.pushState(null, null, newUrl);
	// 	}
	// },

	// get language prefix from url
	getUrlLanguage: () => {
		const url = window.location.pathname.split('/');
		if (url[1] && /^[a-z]{2}(-[a-z]{2})?$/.test(url[1])) {
			return url[1];
		}
		return null;
	},

	// change language prefix in url on dropdown change
	changeUrlLang: (event, selectedLang) => {
		event.preventDefault();

		const currentUrl = window.location.pathname.split('/');

		if (/^[a-z]{2}(-[a-z]{2})?$/.test(currentUrl[1])) {
			currentUrl[1] = selectedLang.toLowerCase();
		} else {
			currentUrl.splice(1, 0, selectedLang.toLowerCase());
		}

		const newUrl = window.location.origin + currentUrl.join('/');
		LanguageSwitcher.setLangCookie(selectedLang);
		window.history.pushState({path: newUrl}, '', newUrl);
	},

	// set language to cookie
	setLangCookie: (selectedLang)=> {
		const expirationDate = new Date();
		expirationDate.setHours(expirationDate.getHours() + 24);

		document.cookie = `url_lang=${selectedLang.toLowerCase()}; expires=${expirationDate.toUTCString()}; path=/;`;
	},

	// change language dropdown on refresh page
	changeLanguage: (langCode)=> {
		const langElement = document.querySelector(`.gt_options a[data-gt-lang="${langCode}"]`);

		if (langElement) {
			langElement.click();

			const wrapper = document.querySelector(window.gtranslateSettings.wrapper_selector);
			if (wrapper) {
				const changeEvent = new Event('change', {bubbles: true});
				wrapper.dispatchEvent(changeEvent);
			}
		}
	},

	//
	// getCookie: function(cname) {
	// 	let name = cname + '=';
	// 	let decodedCookie = decodeURIComponent(document.cookie);
	// 	let ca = decodedCookie.split(';');
	// 	for(let i = 0; i <ca.length; i++) {
	// 		let c = ca[i];
	// 		while (c.charAt(0) === ' ') {
	// 			c = c.substring(1);
	// 		}
	// 		if (c.indexOf(name) === 0) {
	// 			return c.substring(name.length, c.length);
	// 		}
	// 	}
	// 	return '';
	// },
};

export default LanguageSwitcher;
